import useGetRequestBody from "../../useGetRequestBody";
import { getBuyersForSupplier } from "../../../components/user/request/user-requests";
import { useMemo } from "react";
import { LabelValue } from "../../../types/common/LabelValue";
import { NonEmptyArray } from "../../../types/common/NonEmptyArray";
import { SnackbarShowMessage } from "../../../context/snackbar-context";

interface Buyer {
  id: string;
  companyName: string;
}

/**
 * Hook to fetch and format buyers for a supplier as select options.
 * Always returns an array with at least the 'All' option as the first element.
 *
 * @param showMessage - Optional callback to display messages to the user
 * @returns Non-empty array of select options with 'All' as the first option
 */
export const useBuyersBySupplier = (
  showMessage?: SnackbarShowMessage
): NonEmptyArray<LabelValue> => {
  const buyers = useGetRequestBody<Buyer[]>(
    getBuyersForSupplier,
    useMemo(() => [], []),
    showMessage
  );

  return useMemo(
    () => [
      { value: '', label: 'All' },
      ...buyers.map(buyer => ({
        value: buyer.id,
        label: buyer.companyName
      }))
    ],
    [buyers]
  );
};
